import Vue from "vue";
import * as XLSX from './xlsx.mjs';

Vue.prototype.$XLSX = XLSX